import $ from "jquery"

$('.js-accordion-heading').each(function(){
    $(this).on('click', function(){
        if($(this).hasClass('faq-heading-active')){
            $(this).removeClass('faq-heading-active');    
        }else{
            $('.js-accordion-heading').removeClass('faq-heading-active');
            $(this).addClass('faq-heading-active');
        }
    });
});